<template>
	<div class="product-table">
		<p class="product-table__small-title">
			Number of order(s)/item(s) by types:
		</p>
		<table class="product-table__table">
			<thead>
				<tr>
					<th></th>
					<th v-for="eachSummary in summaryTbl" v-bind:key="eachSummary.sku">{{ eachSummary.sku }}</th>
					
				</tr>
			</thead>
			<tbody>
				<tr>
					<th>Total Orders</th>
					<td v-for="eachSummary in summaryTbl" v-bind:key="eachSummary.sku">{{ eachSummary.cnt }}</td>
				</tr>
			</tbody>
		</table>
	</div>
</template>

<script>
import Vue from "vue";
export default Vue.extend({
	name: "",
	components: {},
	computed: {
		summaryTbl: {
			get() {
				return this.$store.getters.scanSummary;
			}
		}
	},
});
</script>

<style lang="scss" scoped>
.product-table {
	padding: 0 0 40px;

	&__small-title {
		text-align: center;
		padding: 10px 0 20px;
		font-weight: 600;
		font-size: 14px;
	}

	&__table {
		margin: 0 auto;

		th,
		td {
			border: 1px solid $border-color;
			text-align: center;
			padding: 7px 0;
			font-size: 14px;
		}

		th {
			background-color: lighten($color7, 10%);
			font-weight: 500;
			width: 140px;
		}

		td {
			background-color: $table-light-bg;
		}
	}
}
</style>